<div style="overflow: hidden; height: 100%;padding-bottom: 20px;">
  <div class="p-card-header flex p-3 gap-2 align-items-center">
    <h3 class="mr-3">Inspection Profiles</h3>
    <p-select *ngIf="inspectionProfileSets" [options]="inspectionProfileSets" optionLabel="name" optionValue="id"
              [(ngModel)]="inspectionProfileId" (onChange)="onInspectionProfileChanged($event)" [group]="true">
      <ng-template let-group pTemplate="group">
        <div style="display: flex; flex-direction: row; justify-content: space-between">
          <div>
            {{ group.name }}
          </div>
          <div>
            <i class="pi pi-trash cursor-pointer" (click)="deleteSet(group.id)"></i>
          </div>
        </div>
      </ng-template>
    </p-select>
    <div class="flex align-items-center">
      <p-button [text]="true" pTooltip="Create New" icon="pi pi-plus" (click)="createInspectionProfile()"></p-button>
      <p-button *ngIf="inspectionProfile" [text]="true" icon="pi pi-trash" severity="danger" mwlConfirmationPopover
                [title]="'Delete Selected Inspection Profile'" [popoverMessage]="
              'You are going to delete selected Inspection Profile. Are you sure?'
            " [appendToBody]="true" [confirmText]="'Yes'" [cancelText]="'No'" placement="bottom"
                (confirm)="removeItProfile()"></p-button>
      <p-button [text]="true" pTooltip="Download" icon="pi pi-download" (click)="downloadInspectionProfile()"
                *ngIf="inspectionProfile && inspectionProfile.id"></p-button>
    </div>
  </div>
  <div style="display: flex; gap: 10px; align-self: center;" *ngIf="inspectionProfile">
    <mat-form-field style="width: 50%">
      <mat-label>Name</mat-label>
      <input matInput [(ngModel)]="inspectionProfile.name" required />
    </mat-form-field>
    <div style="width: 10%">
      <p-select *ngIf="inspectionProfileSets" [options]="setOptions" optionLabel="name" optionValue="id"
                [(ngModel)]="setId">
      </p-select>
      <i class="pi pi-pencil cursor-pointer ml-1" *ngIf="setId" (click)="toggleSetEdit()"></i>
    </div>
    <mat-form-field style="width: 30%" *ngIf="setId === 0">
      <mat-label>New Group Name</mat-label>
      <input matInput [(ngModel)]="newSetName" required />
    </mat-form-field>
    <mat-form-field style="width: 30%" *ngIf="setId !== 0 && isSetEdit">
      <mat-label>New Group Name</mat-label>
      <input matInput [(ngModel)]="setName" required />
    </mat-form-field>
  </div>
  <div style="display: flex; flex-direction: row;" *ngIf="inspectionProfile">
    <div>
      <mat-select [(ngModel)]="inspectionProfile.primaryProjectId" style="min-width: 200px;"
                  placeholder="Project for Naming">
        @for (project of projects; track project.projectId) {
          <mat-option [value]="project.projectId">{{ project.name }}</mat-option>
        }
      </mat-select>
    </div>
    <div style="margin-right: 20px; margin-left: 20px;">
      <mat-select [(ngModel)]="inspectionProfile.routing" style="min-width: 200px;">
        <mat-option [value]="0">Rizkly</mat-option>
        <mat-option [value]="1">External</mat-option>
        <mat-option [value]="2">Both</mat-option>
      </mat-select>
    </div>
    @if (inspectionProfile.routing === 1 || inspectionProfile.routing === 2) {
      <div>
        <mat-select [(ngModel)]="inspectionProfile.integrationId" style="min-width: 200px;" placeholder="Integration">
          @for (integration of integrations; track integration.id) {
            <mat-option [value]="integration.id">{{ integration.name }}</mat-option>
          }
        </mat-select>
      </div>
    }
  </div>
  <div style="display: flex; flex-direction: row;">
    <div style="height: calc(100vh - 240px); position: relative; flex: 1 1 auto; overflow: auto;">
      <i class="pi pi-server cursor-pointer"
         style="display: block; z-index: 10000; position: absolute; top: 10px; right: 10px;"
         (click)="displayPolicies = !displayPolicies"></i>
      <div>
        <button mat-raised-button matTooltip="{{this.constants.JSON_OR_XML_FILE_DESCRIPTION}}"
                (click)="inputFile.click()">
          <i class="pi pi-paperclip"></i>
          Upload Template
        </button>
        <input #inputFile
               type="file"
               accept="{{this.constants.JSON_OR_XML_FILE_EXTENSIONS}}"
               (change)="uploadExample($event)"
               [style.display]="'none'">
      </div>
      <p-table [value]="inspectionProfile?.conditions">
        <ng-template pTemplate="header">
          <tr>
            <th>Active</th>
            <th>Path</th>
            <th>Operator</th>
            <th>Value</th>
            <th style="width: 50px;">IR</th>
            <th style="width: 50px;">Gap</th>
            <th style="width: 100px;">Severity</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr>
            <td style="width: 1%;">
              <p-checkbox [(ngModel)]="item.isActive" [binary]="true"></p-checkbox>
            </td>
            <td style="width: 10%;">
              <b>
                {{ item.path }}
              </b>
            </td>
            <td style="width: 1%;">
              <p-select [options]="operators" optionLabel="name" optionValue="operator" appendTo="body"
                        [(ngModel)]="item.operator">
              </p-select>
            </td>
            <td>
              <mat-form-field style="width: 100%">
                <mat-label>Value</mat-label>
                <input matInput [(ngModel)]="item.value" required />
              </mat-form-field>
            </td>
            <td>
              <mat-slide-toggle [(ngModel)]="item.createIncidentResponse"></mat-slide-toggle>
            </td>
            <td>
              <mat-slide-toggle [(ngModel)]="item.createActionPlan"></mat-slide-toggle>
            </td>
            <td>
              <mat-select [(ngModel)]="item.severity">
                <mat-option [value]="0">Low</mat-option>
                <mat-option [value]="1">Medium</mat-option>
                <mat-option [value]="2">High</mat-option>
              </mat-select>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div style="height: calc(100vh - 240px); position: relative; flex: 0 0 30%; overflow: auto;"
         *ngIf="displayPolicies">
      <p-table [value]="policies" dataKey="id">
        <ng-template pTemplate="header">
          <tr>
            <th colspan="2">Policy</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item let-expanded="expanded">
          <tr [ngStyle]="{backgroundColor: policyMarked[item.id] ? 'grey' : ''}">
            <td style="width:2em;" [pRowToggler]="item">
                        <span>
                          <i [ngClass]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></i>
                        </span>
            </td>
            <td [pRowToggler]="item">{{ item.name }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="expandedrow" let-item>
          <tr>
            <td colspan="2">
              <div *ngFor="let policySection of item.policySections" [ngStyle]="{backgroundColor: policySectionMarked[policySection.policySectionId] ? 'grey' : ''}">
                <h4 *ngIf="policySection.number || policySection.title">
                  {{ policySection.number }}
                  {{ policySection.title }}<br />
                </h4>
                <h5>{{ policySection.subNumber }} {{ policySection.subTitle }}</h5>
                <div [innerHTML]="addToken(policySection.text) | sanitizeHtml"></div>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
  <div style="margin-left: 10px;">
    <button mat-raised-button (click)="onDone()">Save</button>
  </div>
</div>
